import type { FC } from 'react';
import React, { useState } from 'react';
import './index.scss';
import IconText from '../IconText';
import UIicons from '@ui-kit';
// import Picture from '@components/Picture';
import { Picture } from '@ui';
import { observer } from 'mobx-react';
import { twcls } from '@utils/twcls';

const { chevronDown } = UIicons;

interface CollapseProps {
  icon?:
    | string
    | {
        x1: string;
        x2: string;
        x3: string;
      };
  iconHeight?: string;
  text: React.ReactNode;
  arrowHeight?: string;
  children: React.ReactNode;
  isOpened?: boolean;
  marginRight?: string;
  className?: string;
  headerClassName?: string;
}

const Collapse: FC<CollapseProps> = ({
  className,
  headerClassName,
  icon,
  iconHeight,
  text,
  arrowHeight = '24',
  children,
  marginRight = '16',
  isOpened = false
}) => {
  const [isCollapseOpened, setIsCollapseOpened] = useState(isOpened);
  const onHeaderClickHandler = (): void => {
    setIsCollapseOpened(!isCollapseOpened);
  };
  return (
    <div className={twcls('ui-collapse', className)}>
      <div
        onClick={onHeaderClickHandler}
        className={twcls('ui-collapse__header', headerClassName)}
      >
        <IconText
          marginRight={marginRight}
          fontSize='14'
          text={text}
          icon={icon}
          height={iconHeight}
        />
        <Picture
          className={`ui-collapse__arrow${
            isCollapseOpened ? ' ui-collapse__arrow--opened' : ''
          }`}
          icon={chevronDown}
          height={arrowHeight}
        />
      </div>
      {isCollapseOpened && (
        <div className='ui-collapse__content'>{children}</div>
      )}
    </div>
  );
};

export default observer(Collapse);
